// level 1-2: 8  characters
// level 3+: 12 characters
export const calculateMaxLength = (level: number) => {
  return level <= 2 ? 8 : 12;
};

export function randomizeSingleName(level: number): string {
  const maxLength = calculateMaxLength(level);
  let randomIndex = Math.floor(Math.random() * firstNames.length);
  let randomName = firstNames[randomIndex];
  while (randomName.length > maxLength) {
    randomIndex = Math.floor(Math.random() * firstNames.length);
    randomName = firstNames[randomIndex];
  }
  return randomName;
}

export function randomizePlaceOrAdjective(level: number): string {
  const maxLength = calculateMaxLength(level);
  let randomIndex = Math.floor(Math.random() * placesAndAdjectives.length);
  let randomName = placesAndAdjectives[randomIndex];
  while (randomName.length > maxLength) {
    randomIndex = Math.floor(Math.random() * placesAndAdjectives.length);
    randomName = placesAndAdjectives[randomIndex];
  }
  return randomName;
}

// first names from DND, SS, Anime, Norse, Greek, Videogame (google sheet)
const firstNames = [
  'Adrik',
  'Alberich',
  'Baern',
  'Barendd',
  'Brottor',
  'Bruenor',
  'Dain',
  'Darrak',
  'Delg',
  'Eberk',
  'Einkil',
  'Fargrim',
  'Flint',
  'Gardain',
  'Harbek',
  'Kildrak',
  'Morgran',
  'Orsik',
  'Oskar',
  'Rangrim',
  'Rurik',
  'Taklinn',
  'Thoradin',
  'Thorin',
  'Tordek',
  'Traubon',
  'Travok',
  'Ulfgar',
  'Veit',
  'Vondal',
  'Amber',
  'Artin',
  'Audhild',
  'Bardryn',
  'Dagnal',
  'Diesa',
  'Eldeth',
  'Falkrun',
  'Finellen',
  'Gunnloda',
  'Gurdis',
  'Helja',
  'Hlin',
  'Kathra',
  'Kristryd',
  'Ilde',
  'Liftrasa',
  'Mardred',
  'Riswynn',
  'Sannl',
  'Torbera',
  'Torgga',
  'Vistra',
  'Balderk',
  'Battlehammer',
  'Brawnanvil',
  'Dankil',
  'Fireforge',
  'Frostbeard',
  'Gorunn',
  'Holderhek',
  'Ironfist',
  'Loder',
  'Lutgehr',
  'Rumnaheim',
  'Strakeln',
  'Torunn',
  'Ungart',
  'Adran',
  'Aelar',
  'Aramil',
  'Arannis',
  'Aust',
  'Beiro',
  'Berrian',
  'Carric',
  'Enialis',
  'Erdan',
  'Erevan',
  'Galinndan',
  'Hadarai',
  'Heian',
  'Himo',
  'Immeral',
  'Ivellios',
  'Laucian',
  'Mindartis',
  'Paelias',
  'Peren',
  'Quarion',
  'Riardon',
  'Rolen',
  'Soveliss',
  'Thamior',
  'Tharivol',
  'Theren',
  'Varis',
  'Adrie',
  'Althaea',
  'anastrianna',
  'Andraste',
  'Antinua',
  'Bethrynna',
  'Birel',
  'Caelynn',
  'Drusilia',
  'Enna',
  'Felosial',
  'Ielenia',
  'Jelenneth',
  'Keyleth',
  'Leshanna',
  'Lia',
  'Meriele',
  'Mialee',
  'Naivara',
  'Quelenna',
  'Quillathe',
  'Sariel',
  'Shanairra',
  'Shava',
  'Silaqui',
  'Theirastra',
  'Thia',
  'Vadania',
  'Valanthe',
  'Xanaphia',
  'Amakir',
  'Amastacia',
  'Galanodel',
  'Holimion',
  'Ilphelkiir',
  'Liadon',
  'Meliamne',
  'Nailo',
  'Siannodel',
  'Xiloscient',
  'Alston',
  'Alvyn',
  'Boddynock',
  'Brocc',
  'Burgell',
  'Dimble',
  'Eldon',
  'Erky',
  'Fonkin',
  'Frug',
  'Gerbo',
  'Gimble',
  'Glim',
  'Jebeddo',
  'Kellen',
  'Namfoodle',
  'Orryn',
  'Seebo',
  'Sindri',
  'Warryn',
  'Wrenn',
  'Zook',
  'Bimpnottin',
  'Breena',
  'Caramip',
  'Carlin',
  'Donella',
  'Duvamil',
  'Ella',
  'Ellyjobell',
  'Ellywick',
  'Lilli',
  'Loopmottin',
  'Lorilla',
  'Mardnab',
  'Nissa',
  'Nyx',
  'Oda',
  'Orla',
  'Roywyn',
  'Shamil',
  'Tana',
  'Waywocket',
  'Zanna',
  'Beren',
  'Daergel',
  'Folkor',
  'Garrick',
  'Nackle',
  'Murnig',
  'Ningel',
  'Raulnor',
  'Scheppen',
  'Timbers',
  'Turen',
  'Alton',
  'Ander',
  'Cade',
  'Corrin',
  'Eldon',
  'Errich',
  'Finnan',
  'Garret',
  'Lindal',
  'Lyle',
  'Merric',
  'Milo',
  'Osborn',
  'Perrin',
  'Reed',
  'Roscoe',
  'Wellby',
  'Andry',
  'Bree',
  'Callie',
  'Cora',
  'Euphemia',
  'Jillian',
  'Kithri',
  'Lavinia',
  'Lidda',
  'Merla',
  'Nedda',
  'Paela',
  'Portia',
  'Seraphina',
  'Shaena',
  'Trym',
  'Vani',
  'Verna',
  'Brushgather',
  'Goodbarrel',
  'Greenbottle',
  'High-hill',
  'Hilltopple',
  'Leagallow',
  'Tealeaf',
  'Thorngage',
  'Tosscobble',
  'Underbough',
  'Arjhan',
  'Balasar',
  'Bharash',
  'Donaar',
  'Ghesh',
  'Heskan',
  'Kriv',
  'Medrash',
  'Mehen',
  'Nadarr',
  'Pandjed',
  'Patrin',
  'Rhogar',
  'Shamash',
  'Shedinn',
  'Tarhun',
  'Torinn',
  'Akra',
  'Biri',
  'Daar',
  'Farideh',
  'Harann',
  'Havilar',
  'Jheri',
  'Kava',
  'Korinn',
  'Mishann',
  'Nala',
  'Perra',
  'Raiann',
  'Sora',
  'Surina',
  'Thava',
  'Uadjit',
  'Clethinthiallor',
  'Daardemdroam',
  'Delmirev',
  'Drachedandion',
  'Fenkenkabradon',
  'Kepeshkmolik',
  'Kerrhylon',
  'Kimbatuul',
  'Linxakasendalor',
  'Myastan',
  'Nemmonis',
  'Norixius',
  'Ophinshtalajiir',
  'Prexijandilin',
  'Shestendeliath',
  'Turnuroth',
  'Verthisathurgiesh',
  'Yarjerit',
  'Dench',
  'Feng',
  'Gell',
  'Henk',
  'Holg',
  'Imsh',
  'Keth',
  'Krusk',
  'Mhurren',
  'Ront',
  'Shump',
  'Thokk',
  'Baggi',
  'Emen',
  'Engong',
  'Kansif',
  'Myev',
  'Neega',
  'Ovak',
  'Ownka',
  'Shautha',
  'Sutha',
  'Vola',
  'Volen',
  'Yevelda',
  'Akmenos',
  'Amnon',
  'Barakas',
  'Damakos',
  'Ekemon',
  'Iados',
  'Kairon',
  'Leucis',
  'Melech',
  'Mordai',
  'Morthos',
  'Pelaios',
  'Skamos',
  'Therai',
  'Akta',
  'Anakis',
  'Bryseis',
  'Criella',
  'Damaia',
  'Ea',
  'Kallista',
  'Lerissa',
  'Makaria',
  'Nemeia',
  'Orianna',
  'Phelaia',
  'Rieta',
  'Art',
  'Carrion',
  'Chant',
  'Creed',
  'Despair',
  'Excellence',
  'Fear',
  'Glory',
  'Hope',
  'Ideal',
  'Music',
  'Nowhere',
  'Open',
  'Poetry',
  'Quest',
  'Random',
  'Reverence',
  'Sorrow',
  'Temerity',
  'Torment',
  'Weary',
  'Arix',
  'Eks',
  'Ett',
  'Galax',
  'Garu',
  'Hagnar',
  'Hox',
  'Irtos',
  'Kashak',
  'Meepo',
  'Molo',
  'Ohsoss',
  'Rotom',
  'Sagin',
  'Sik',
  'Sniv',
  'Taklak',
  'Tes',
  'Urak',
  'Varn',
  'Aseir',
  'Bardeid',
  'Haseid',
  'Khemed',
  'Mehmen',
  'Sudeiman',
  'Zasheir',
  'Bor',
  'Fodel',
  'Glar',
  'Grigor',
  'Igan',
  'Ivor',
  'Kosef',
  'Mival',
  'Orel',
  'Pavel',
  'Sergor',
  'Amiri',
  'Eliam',
  'Colter',
  'Ozzy',
  'Loyal',
  'Khai',
  'Evander',
  'Camilo',
  'Mac',
  'Jiraiya',
  'Banks',
  'Gian',
  'Wylder',
  'Elio',
  'Kylian',
  'Cillian',
  'Bridger',
  'Onyx',
  'Zyair',
  'Koen',
  'Palmer',
  'Azriel',
  'Zyon',
  'Rome',
  'Azael',
  'Osman',
  'Westin',
  'Avyaan',
  'Jakai',
  'Aziel',
  'Riggs',
  'Bowie',
  'Yaakov',
  'Mustafa',
  'Kartier',
  'Ambrose',
  'Callahan',
  'Jesiah',
  'Dario',
  'Jaxxon',
  'Tru',
  'Wes',
  'Yadiel',
  'Alfonso',
  'Neo',
  'Avi',
  'Zakai',
  'Rey',
  'Saint',
  'Creed',
  'Stetson',
  'Granger',
  'Mccoy',
  'Atreus',
  'Bellamy',
  'Tatum',
  'Elon',
  'Houston',
  'Miller',
  'Rio',
  'Tadeo',
  'Jericho',
  'Howard',
  'Coleson',
  'Augustine',
  'Amos',
  'Kyro',
  'Azrael',
  'Bodie',
  'Jamie',
  'Salem',
  'Forest',
  'Calum',
  'Ocean',
  'Jamir',
  'Krew',
  'Everest',
  'Morgan',
  'Ares',
  'Yisroel',
  'Castiel',
  'Kaiser',
  'Cayson',
  'Walker',
  'Franco',
  'Benedict',
  'Callen',
  'Baker',
  'Casey',
  'Bear',
  'Shepherd',
  'Seven',
  'Magnus',
  'Louie',
  'Lee',
  'Blaze',
  'Koda',
  'Cassian',
  'Ridge',
  'Archie',
  'Niko',
  'Brixton',
  'Nikolai',
  'Briggs',
  'Santos',
  'Jakari',
  'Brodie',
  'Damir',
  'Alistair',
  'Dariel',
  'Wells',
  'Cal',
  'Grey',
  'Callum',
  'Adrien',
  'Turner',
  'Kenji',
  'Anakin',
  'Valentino',
  'Marcelo',
  'Zyaire',
  'Callan',
  'Wilder',
  'Nico',
  'Braylon',
  'Niklaus',
  'Legacy',
  'Zeke',
  'Ledger',
  'Bo',
  'Mylo',
  'Kohen',
  'Sylas',
  'Harlan',
  'Lian',
  'Memphis',
  'Wesson',
  'Aryan',
  'Baylor',
  'Otto',
  'Forrest',
  'Caspian',
  'Hank',
  'Ari',
  'Apollo',
  'Tate',
  'Remi',
  'Luka',
  'Jamal',
  'Bruno',
  'Jovanni',
  'Trey',
  'Lucian',
  'Davion',
  'Kiaan',
  'Deacon',
  'Collin',
  'Truett',
  'Sonny',
  'Ace',
  'Briar',
  'Augustus',
  'Leland',
  'Milan',
  'Zahir',
  'Damari',
  'Agustin',
  'Leandro',
  'Sutton',
  'Finley',
  'Gordon',
  'Rudy',
  'Tripp',
  'Alijah',
  'Atlas',
  'Alfredo',
  'Cannon',
  'Ignacio',
  'Byron',
  'Koa',
  'Lennox',
  'Shiloh',
  'Braylen',
  'Reed',
  'Cade',
  'Rayden',
  'Carmelo',
  'Azariah',
  'Jaziel',
  'Royal',
  'Rory',
  'Enzo',
  'Reuben',
  'Reign',
  'Moshe',
  'Mack',
  'Esteban',
  'Quinn',
  'Finnegan',
  'Atticus',
  'Jett',
  'August',
  'Waylon',
  'Jakob',
  'Dustin',
  'Vance',
  'Jones',
  'Fisher',
  'Jalen',
  'Jasiah',
  'Brady',
  'Felix',
  'Malakai',
  'Dimitri',
  'Zayn',
  'Arlo',
  'Theo',
  'Heath',
  'Eithan',
  'Thatcher',
  'Neil',
  'Clay',
  'Colson',
  'Hassan',
  'Reese',
  'Justice',
  'Romeo',
  'Kabir',
  'Layne',
  'Dexter',
  'Kieran',
  'Bowen',
  'Ezequiel',
  'Jacoby',
  'Beckham',
  'Thiago',
  'Ephraim',
  'Leroy',
  'Demetrius',
  'Mohamed',
  'Santino',
  'Sullivan',
  'Luca',
  'Guillermo',
  'Cairo',
  'Graham',
  'Alvaro',
  'Maurice',
  'Trace',
  'Maximo',
  'Joziah',
  'Saul',
  'Roy',
  'Drew',
  'Archer',
  'Kai',
  'Wallace',
  'Denver',
  'Ford',
  'Zane',
  'Lennon',
  'Noel',
  'Franklin',
  'Raiden',
  'Cyrus',
  'Atharv',
  'Kalel',
  'Orlando',
  'Tyson',
  'Leon',
  'River',
  'Jabari',
  'Kelvin',
  'Donald',
  'Nikolas',
  'Sterling',
  'Amari',
  'Messiah',
  'Rene',
  'Tommy',
  'Zayne',
  'Russell',
  'Colin',
  'Kairo',
  'Lorenzo',
  'Dash',
  'Chris',
  'Oakley',
  'Julius',
  'Reid',
  'Hayes',
  'Knox',
  'Salvatore',
  'Alessandro',
  'Finnley',
  'Conrad',
  'Shane',
  'Francis',
  'Wade',
  'Crew',
  'Kash',
  'Charlie',
  'Beau',
  'Brooks',
  'Kenzo',
  'Royce',
  'Nicolas',
  'Wesley',
  'Hamza',
  'Theodore',
  'Adler',
  'Bjorn',
  'Casen',
  'Yusuf',
  'Cash',
  'Riley',
  'Caden',
  'Beckett',
  'Dominik',
  'Khalid',
  'Junior',
  'Marcellus',
  'Alexis',
  'Orion',
  'Gideon',
  'Bodhi',
  'Kayson',
  'Tucker',
  'Dean',
  'Rhett',
  'Bennett',
  'Ezekiel',
  'Henrik',
  'Asa',
  'Lewis',
  'Frederick',
  'Dax',
  'Sage',
  'Clayton',
  'Rafael',
  'Emilio',
  'Jasper',
  'Jack',
  'Kase',
  'Yehuda',
  'Hezekiah',
  'Danny',
  'Omari',
  'Adan',
  'Leonidas',
  'Kane',
  'Derek',
  'Louis',
  'Griffin',
  'Legend',
  'Weston',
  'Silas',
  'Angel',
  'Hudson',
  'Reece',
  'Jamari',
  'Rhys',
  'Desmond',
  'Malcolm',
  'Hendrix',
  'Arthur',
  'Zion',
  'Santiago',
  'Alonso',
  'Ben',
  'Rodrigo',
  'Paxton',
  'Nash',
  'Matteo',
  'Rowan',
  'Everett',
  'Ezra',
  'Asher',
  'Vicente',
  'Flynn',
  'Watson',
  'Boone',
  'Rowen',
  'Zaiden',
  'Ruben',
  'Kashton',
  'Cruz',
  'Kingston',
  'Cooper',
  'Elias',
  'Levi',
  'Gatlin',
  'Axton',
  'Jay',
  'Killian',
  'Ellis',
  'Alejandro',
  'Milo',
  'Myles',
  'Jose',
  'Miles',
  'Caleb',
  'Leo',
  'Mateo',
  'Raya',
  'Wrenley',
  'Angelique',
  'Vida',
  'Emberlynn',
  'Flora',
  'Murphy',
  'Arleth',
  'Ocean',
  'Oakleigh',
  'Freyja',
  'Mylah',
  'Taytum',
  'Elia',
  'Jaylani',
  'Zayla',
  'Navy',
  'Della',
  'Clover',
  'Nyra',
  'Halo',
  'Soleil',
  'Soraya',
  'Marceline',
  'Jenesis',
  'Noah',
  'Sylvie',
  'Loyalty',
  'Jovie',
  'Kahlani',
  'Dalia',
  'Aila',
  'Journi',
  'Analia',
  'Goldie',
  'Alora',
  'Fallon',
  'Oaklee',
  'Noa',
  'Baylor',
  'Drew',
  'Halle',
  'Kamari',
  'Daphne',
  'Salma',
  'Margo',
  'Indigo',
  'Denver',
  'Stevie',
  'Anya',
  'Danna',
  'Kiana',
  'Promise',
  'Austyn',
  'Lainey',
  'Giana',
  'Hadlee',
  'Zendaya',
  'Wren',
  'Tatiana',
  'Birdie',
  'Opal',
  'Aiyana',
  'Ila',
  'Oaklynn',
  'Sandra',
  'Iyla',
  'Salem',
  'Azariah',
  'Layne',
  'Jazlyn',
  'Nellie',
  'Theodora',
  'Kori',
  'Rosalia',
  'Saige',
  'Sevyn',
  'Artemis',
  'Bonnie',
  'Adelina',
  'Marisol',
  'Sloan',
  'Sky',
  'Kataleya',
  'Oakley',
  'Elisa',
  'Octavia',
  'Anais',
  'Calliope',
  'Cataleya',
  'Whitley',
  'Mara',
  'Harlow',
  'Bexley',
  'Naya',
  'Chandler',
  'Winnie',
  'Mavis',
  'Elora',
  'Aliya',
  'Jianna',
  'Thalia',
  'Faye',
  'Avayah',
  'Selene',
  'Cleo',
  'Sutton',
  'Malani',
  'India',
  'Colette',
  'Micah',
  'Yareli',
  'Estella',
  'Mina',
  'Eleanora',
  'Jaycee',
  'Mae',
  'Holland',
  'Rosemary',
  'Zariyah',
  'Celine',
  'Kaia',
  'Ophelia',
  'Billie',
  'Dani',
  'Michaela',
  'Legacy',
  'Amira',
  'Ellison',
  'Alessia',
  'Malayah',
  'Sariyah',
  'Keilani',
  'Azaria',
  'Hadleigh',
  'Cynthia',
  'Maia',
  'Tatum',
  'Jaylene',
  'Lennon',
  'Rory',
  'Lyra',
  'Noemi',
  'Kalani',
  'Lorelei',
  'Azalea',
  'Annie',
  'Arlette',
  'Indie',
  'Annalise',
  'Hallie',
  'Kaylani',
  'Araceli',
  'Belen',
  'Xiomara',
  'Poppy',
  'Dream',
  'Estelle',
  'Aarna',
  'Luella',
  'Paloma',
  'Alaiya',
  'Capri',
  'Davina',
  'Alma',
  'Liana',
  'Charli',
  'Clementine',
  'Briar',
  'Mazikeen',
  'Addilyn',
  'Mabel',
  'Nyomi',
  'Zora',
  'Dorothy',
  'Gia',
  'Kimora',
  'Veda',
  'Aliana',
  'Paityn',
  'Florence',
  'Cassandra',
  'Maeve',
  'Martha',
  'Lilith',
  'Loretta',
  'Laurel',
  'Guinevere',
  'Myla',
  'Persephone',
  'Ariya',
  'Ryder',
  'Natasha',
  'Khalani',
  'Shiloh',
  'Dahlia',
  'Delaney',
  'Sage',
  'Kaiya',
  'Treasure',
  'Sunny',
  'Selah',
  'Nayeli',
  'Saylor',
  'Alisson',
  'Livia',
  'Tiana',
  'Scout',
  'Louise',
  'Margot',
  'Alani',
  'Magdalena',
  'Novalee',
  'Bristol',
  'Selena',
  'Elaine',
  'Sylvia',
  'Skye',
  'Collins',
  'Sloane',
  'Emerald',
  'Maxine',
  'Anne',
  'Virginia',
  'Louisa',
  'Magnolia',
  'Sasha',
  'Makenna',
  'River',
  'Alina',
  'Marleigh',
  'Serena',
  'Ariyah',
  'Talia',
  'Ayleen',
  'Bailee',
  'Juniper',
  'Bellamy',
  'Joelle',
  'Ivory',
  'Jimena',
  'Francesca',
  'Wynter',
  'Celeste',
  'Marlowe',
  'Karter',
  'Paulina',
  'Blaire',
  'Liberty',
  'Adley',
  'Elianna',
  'Journey',
  'Khaleesi',
  'Ruth',
  'Shay',
  'Ellis',
  'Rivka',
  'Eileen',
  'Aisha',
  'Zuri',
  'Eloise',
  'Brittany',
  'Noor',
  'Berkley',
  'Bridget',
  'Sierra',
  'Avianna',
  'Amy',
  'Megan',
  'Freya',
  'Kai',
  'Ellianna',
  'Amalia',
  'Evie',
  'Leilani',
  'Stormi',
  'Siena',
  'Armani',
  'Frances',
  'Haven',
  'Ember',
  'Lucia',
  'Zainab',
  'Lara',
  'Camryn',
  'Leighton',
  'Aspen',
  'Ayla',
  'Kathleen',
  'Mariana',
  'Sawyer',
  'Elina',
  'Pearl',
  'Penny',
  'Marie',
  'Cameron',
  'Nyla',
  'Blake',
  'Kiera',
  'Iris',
  'Ramona',
  'Aileen',
  'Blair',
  'Evangeline',
  'Diana',
  'Joyce',
  'Lina',
  'Mallory',
  'Jolene',
  'Allie',
  'Esme',
  'Lana',
  'Vera',
  'Kehlani',
  'Raquel',
  'Mercy',
  'Lilian',
  'Emberly',
  'Monroe',
  'Palmer',
  'Angela',
  'Sienna',
  'Hunter',
  'Kyra',
  'Lylah',
  'Gemma',
  'Millie',
  'Emersyn',
  'Autumn',
  'Kayleigh',
  'Madeleine',
  'Cecilia',
  'Josephine',
  'Lexie',
  'Valery',
  'Melina',
  'Savanna',
  'Macie',
  'Holly',
  'Sarai',
  'Rowan',
  'Olive',
  'Genevieve',
  'Milena',
  'Jamie',
  'Reyna',
  'Meredith',
  'Cecelia',
  'Ailani',
  'Carter',
  'Remington',
  'Lilly',
  'Rosalie',
  'Catalina',
  'Blakely',
  'Parker',
  'August',
  'Rhea',
  'Aurelia',
  'Matilda',
  'Elle',
  'Adelynn',
  'Adelaide',
  'Elsie',
  'Georgia',
  'Alice',
  'Ruby',
  'Giavanna',
  'Estrella',
  'Mckinley',
  'Astrid',
  'Jordan',
  'Juliet',
  'Maggie',
  'Isabel',
  'Delilah',
  'Isla',
  'Baylee',
  'Rosie',
  'Ana',
  'Bailey',
  'Summer',
  'Athena',
  'Chaya',
  'Chelsea',
  'Raven',
  'Kendall',
  'Daisy',
  'Eden',
  'Ivy',
  'Willow',
  'Rosalyn',
  'Nadia',
  'Regina',
  'Reign',
  'Madilyn',
  'Malia',
  'Noelle',
  'Lyla',
  'Monica',
  'Laney',
  'Malaysia',
  'Karsyn',
  'Adrianna',
  'Ari',
  'Evelynn',
  'Logan',
  'Charlee',
  'Miriam',
  'Phoebe',
  'Arabella',
  'June',
  'Eleanor',
  'Janelle',
  'Kailani',
  'Journee',
  'Liliana',
  'Jade',
  'Maya',
  'Nova',
  'Luisa',
  'Andi',
  'Itzel',
  'Kaliyah',
  'Danielle',
  'Maisie',
  'Royalty',
  'Lila',
  'Brynlee',
  'Ada',
  'Rylee',
  'Adeline',
  'Lydia',
  'Quinn',
  'Natalia',
  'Eliana',
  'Aria',
  'James',
  'Robert',
  'John',
  'Michael',
  'David',
  'William',
  'Richard',
  'Joseph',
  'Thomas',
  'Charles',
  'Christopher',
  'Daniel',
  'Matthew',
  'Anthony',
  'Mark',
  'Donald',
  'Steven',
  'Paul',
  'Andrew',
  'Joshua',
  'Kenneth',
  'Kevin',
  'Brian',
  'George',
  'Timothy',
  'Ronald',
  'Edward',
  'Jason',
  'Jeffrey',
  'Ryan',
  'Jacob',
  'Gary',
  'Nicholas',
  'Eric',
  'Jonathan',
  'Stephen',
  'Larry',
  'Justin',
  'Scott',
  'Brandon',
  'Benjamin',
  'Samuel',
  'Gregory',
  'Alexander',
  'Frank',
  'Patrick',
  'Raymond',
  'Jack',
  'Dennis',
  'Jerry',
  'Tyler',
  'Aaron',
  'Jose',
  'Adam',
  'Nathan',
  'Henry',
  'Douglas',
  'Zachary',
  'Peter',
  'Kyle',
  'Ethan',
  'Walter',
  'Noah',
  'Jeremy',
  'Christian',
  'Keith',
  'Roger',
  'Terry',
  'Gerald',
  'Harold',
  'Sean',
  'Austin',
  'Carl',
  'Arthur',
  'Lawrence',
  'Dylan',
  'Jesse',
  'Jordan',
  'Bryan',
  'Billy',
  'Joe',
  'Bruce',
  'Gabriel',
  'Logan',
  'Albert',
  'Willie',
  'Alan',
  'Juan',
  'Wayne',
  'Elijah',
  'Randy',
  'Roy',
  'Vincent',
  'Ralph',
  'Eugene',
  'Russell',
  'Bobby',
  'Mason',
  'Philip',
  'Louis',
  'Mary',
  'Patricia',
  'Jennifer',
  'Linda',
  'Elizabeth',
  'Barbara',
  'Susan',
  'Jessica',
  'Sarah',
  'Karen',
  'Lisa',
  'Nancy',
  'Betty',
  'Margaret',
  'Sandra',
  'Ashley',
  'Kimberly',
  'Emily',
  'Donna',
  'Michelle',
  'Carol',
  'Amanda',
  'Dorothy',
  'Melissa',
  'Deborah',
  'Stephanie',
  'Rebecca',
  'Sharon',
  'Laura',
  'Cynthia',
  'Kathleen',
  'Amy',
  'Angela',
  'Shirley',
  'Anna',
  'Brenda',
  'Pamela',
  'Emma',
  'Nicole',
  'Helen',
  'Samantha',
  'Katherine',
  'Christine',
  'Debra',
  'Rachel',
  'Carolyn',
  'Janet',
  'Catherine',
  'Maria',
  'Heather',
  'Diane',
  'Ruth',
  'Julie',
  'Olivia',
  'Joyce',
  'Virginia',
  'Victoria',
  'Kelly',
  'Lauren',
  'Christina',
  'Joan',
  'Evelyn',
  'Judith',
  'Megan',
  'Andrea',
  'Cheryl',
  'Hannah',
  'Jacqueline',
  'Martha',
  'Gloria',
  'Teresa',
  'Ann',
  'Sara',
  'Madison',
  'Frances',
  'Kathryn',
  'Janice',
  'Jean',
  'Abigail',
  'Alice',
  'Julia',
  'Judy',
  'Sophia',
  'Grace',
  'Denise',
  'Amber',
  'Doris',
  'Marilyn',
  'Danielle',
  'Beverly',
  'Isabella',
  'Theresa',
  'Diana',
  'Natalie',
  'Brittany',
  'Charlotte',
  'Marie',
  'Kayla',
  'Alexis',
  'Lori',
  'Aiko',
  'Aimi',
  'Aina',
  'Airi',
  'Akane',
  'Akemi',
  'Aki',
  'Akihiro',
  'Akio',
  'Akira',
  'Alex',
  'Allen',
  'Alphonse',
  'Amaterasu',
  'Ami',
  'Aoi',
  'Arata',
  'Araysh',
  'Asami',
  'Ash',
  'Astro',
  'Asuka',
  'Atsuko',
  'Aya',
  'Ayaka',
  'Ayako',
  'Ayame',
  'Ayane',
  'Ayano',
  'Ayumu',
  'Betzalel',
  'Blagdan',
  'Brock',
  'Captain',
  'Chaiyn',
  'Chieko',
  'Chiharu',
  'Chika',
  'Chikako',
  'Chinatsu',
  'Chiyo',
  'Chiyoko',
  'Cho',
  'Chouko',
  'Cygnus',
  'Dai',
  'Daichi',
  'Daiki',
  'Daisuke',
  'Dante',
  'Devroop',
  'Draven',
  'Druvish',
  'Duke',
  'Dunnere',
  'Edward',
  'Eiko',
  'Elric',
  'Emiko',
  'Erembour',
  'Erembourc',
  'Etsuko',
  'Faye',
  'Fumiko',
  'Fumio',
  'Goro',
  'Hachiro',
  'Hajime',
  'Hana',
  'Hanako',
  'Haru',
  'Haruka',
  'Haruki',
  'Haruko',
  'Harumi',
  'Haruna',
  'Haruo',
  'Haruto',
  'Hayate',
  'Hayato',
  'Hibiki',
  'Hideaki',
  'Hideki',
  'Hideo',
  'Hikari',
  'Hikaru',
  'Hina',
  'Hinata',
  'Hiraku',
  'Hiro',
  'Hiroaki',
  'Hiroki',
  'Hiroko',
  'Hiromi',
  'Hironori',
  'Hiroshi',
  'Hiroto',
  'Hiroyuki',
  'Hisako',
  'Hisashi',
  'Hisoka',
  'Hitomi',
  'Hitoshi',
  'Honoka',
  'Hoshi',
  'Hoshiko',
  'Hotaka',
  'Hotaru',
  'Ichiro',
  'Isamu',
  'Isao',
  'Itachi',
  'Itsuki',
  'Izumi',
  'Jin',
  'Jiro',
  'Jun',
  'JunichiJunko',
  'Juro',
  'Kaede',
  'Kaito',
  'Kamiko',
  'Kanako',
  'Kanon',
  'Kaori',
  'Kaoru',
  'Kardama',
  'Kasumi',
  'Katashi',
  'Katsu',
  'Katsumi',
  'Katsuo',
  'Katsuro',
  'Kazue',
  'Kazuhiko',
  'Kazuhiro',
  'Kazuki',
  'Kazuko',
  'Kazumi',
  'Kazuo',
  'Kei',
  'Keiko',
  'Ken',
  'Kenichi',
  'Kenta',
  'Kichiro',
  'Kiko',
  'Kiku',
  'Kimi',
  'Kimiko',
  'Kira',
  'Kiyoko',
  'Kiyomi',
  'Kiyoshi',
  'Kohaku',
  'Kokoro',
  'Kotone',
  'Kouki',
  'Kouta',
  'Kumiko',
  'Kunio',
  'Kuro',
  'Kyoko',
  'Levi',
  'Madoka',
  'Maiko',
  'majestic',
  'Maki',
  'Makoto',
  'Mami',
  'Mamoru',
  'Mana',
  'Manabu',
  'Manami',
  'Mariko',
  'Masaaki',
  'Masahiko',
  'Masahiro',
  'Masaji',
  'Masaki',
  'Masami',
  'Masanori',
  'Masao',
  'Masaru',
  'Masashi',
  'Masato',
  'Masayoshi',
  'Masayuki',
  'Masumi',
  'Masuyo',
  'Mayu',
  'Mayumi',
  'Megumi',
  'Michi',
  'Michiaki',
  'Michiko',
  'Michio',
  'Midori',
  'Mieko',
  'Miho',
  'Mika',
  'Mikasa',
  'Miki',
  'Mikio',
  'Miku',
  'Minako',
  'Misaki',
  'Mitsuko',
  'Mitsuo',
  'Mitsuru',
  'Miwa',
  'Miyako',
  'Miyu',
  'Miyuki',
  'Mizuki',
  'Moe',
  'Mohandas',
  'Mohanjot',
  'Momoe',
  'Momoka',
  'Momoko',
  'Moon',
  'Moriko',
  'Motoko',
  'Nana',
  'Nanami',
  'Naoki',
  'Naoko',
  'Naomi',
  'Natsu',
  'Natsuki',
  'Natsuko',
  'Natsumi',
  'Niratap',
  'Nizhalgal',
  'Noboru',
  'Nobu',
  'Nobuko',
  'Nobuo',
  'Noburu',
  'Nori',
  'Noriko',
  'Norio',
  'Ootori',
  'Osamu',
  'Raiden',
  'Ranmaru',
  'Reiko',
  'Rika',
  'Riko',
  'Riku',
  'Rikuto',
  'Rina',
  'Rio',
  'Rokuro',
  'Roy',
  'Rukia',
  'Ryo',
  'Ryoichi',
  'Ryoko',
  'Ryota',
  'Ryoto',
  'Ryuu',
  'Ryuunosuke',
  'Saburo',
  'Sachiko',
  'Sadao',
  'Sailor',
  'Sakurako',
  'Satashi',
  'Satoko',
  'Satomi',
  'Satoru',
  'Satuoru',
  'Sayuri',
  'Seiichi',
  'Seiji',
  'Setsuko',
  'Shichiro',
  'Shigeko',
  'Shika',
  'Shikamaru',
  'Shin',
  'Shinichi',
  'Shinichiro',
  'Shinji',
  'Shinobu',
  'Shiro',
  'Shizuka',
  'Shizuko',
  'Shoichi',
  'Shouta',
  'Shuichi',
  'Shuji',
  'Shun',
  'Sora',
  'Souta',
  'Spike',
  'Sumiko',
  'Susumu',
  'Suzume',
  'Tadao',
  'Tadashi',
  'Taiki',
  'Takao',
  'Takara',
  'Taro',
  'Tatsuya',
  'Tirich',
  'Tomiko',
  'Tomio',
  'Toru',
  'Toshiro',
  'Tsubame',
  'Tsubasa',
  'Umeko',
  'Usagi',
  'Wakana',
  'Wasaki',
  'Wendy',
  'Yahiko',
  'Yamoto',
  'Yasu',
  'Yoko',
  'Yori',
  'Yoshikazu',
  'Yuichi',
  'Yukio',
  'Yumi',
  'Yuri',
  'Yuuki',
  'Yuuto',
  'Yuzuki',
  'Áli or Váli',
  'Baldur',
  'Bil',
  'Bragi',
  'Eir',
  'Forseti',
  'Forsseih',
  'Freyja',
  'Freyr',
  'Frigg',
  'Fulla',
  'Gefjon',
  'Gerd',
  'Gerð',
  'Gná',
  'Heimdal',
  'Hlín',
  'Hnoss',
  'Höðr',
  'Hœnir',
  'Iðunn',
  'Ilm',
  'Jörð',
  'Lofn',
  'Loki',
  'Nanna',
  'Njörðr',
  'Njörður',
  'Njörun',
  'od',
  'Óðinn',
  'Rán',
  'Rind',
  'Sága',
  'Sigyn',
  'Sjöfn',
  'Skadi',
  'Snotra',
  'Sol',
  'Syn',
  'Thor',
  'Týr',
  'Ullr',
  'Váli',
  'Vár',
  'Víðar',
  'Vör',
  'Ygg',
  'Yngvi-Freyr',
  'Þór',
  'Þrúð',
  'Aeolus',
  'Aphrodite',
  'Apollo',
  'Ares',
  'Ariadne',
  'Artemis',
  'Asclepius',
  'Asteria',
  'Asterious',
  'Athena',
  'Atlas',
  'Bia',
  'Chaos',
  'Cratos',
  'Deimos',
  'Demeter',
  'Dione',
  'Dionysus',
  'Eileithyia',
  'Enyo',
  'Eos',
  'Epimetheus',
  'Erebus',
  'Eris',
  'Eros',
  'Gaia',
  'Ganymede',
  'Geras',
  'Hades',
  'Harmonia',
  'Hebe',
  'Hecate',
  'Helios',
  'Hephaestus',
  'Hera',
  'Hermes',
  'Hestia',
  'Hyperion',
  'Hypnos',
  'Iapetos',
  'Iris',
  'Janus',
  'Khione',
  'Koios',
  'Krios',
  'Kronos',
  'Leto',
  'Melinoe',
  'Menoitios',
  'Metis',
  'Mnemosyne',
  'Momus',
  'Moros',
  'Morpheus',
  'Nemesis',
  'Nike',
  'Nyx',
  'Oceanus',
  'Ouranos',
  'Paean',
  'Pallas',
  'Pan',
  'Persephone',
  'Perses',
  'Phanes',
  'Phobos',
  'Phoebe',
  'Poseidon',
  'Prometheus',
  'Psyche',
  'Rhea',
  'Selene',
  'Tartarus',
  'Tethys',
  'Thanatos',
  'The Anemois',
  'Theia',
  'Themis',
  'Thesis',
  'Triton',
  'Tyche',
  'Zelus',
  'Zeus',
  'Banjo',
  'Bonnie',
  'Bowser',
  'Cloud',
  'Shepard',
  'Cortana',
  'Deckard',
  'Diddy',
  'Donkey',
  'Duke',
  'Jim',
  'Ezio',
  'Fargoth',
  'Ganondorf',
  'Geralt',
  'GLaDOS',
  'Gordon',
  'Jack',
  'Jack',
  'John',
  'Jonathan',
  'Kitana',
  'Kratos',
  'Lara',
  'Link',
  'Marcus',
  'Mario',
  'Master',
  'Max',
  'McCree',
  'Megaman',
  'Nathan',
  'Pacman',
  'Pikachu',
  'Icarus',
  'Peach',
  'Zelda',
  'Rayman',
  'Rayne',
  'Ryu',
  'Sam',
  'Samus',
  'Sarah',
  'Scorpion',
  'Solid',
  'Sonic',
  'Spyro',
  'Subzero',
  'Urdnot',
];

const placesAndAdjectives = [
  'Aaru',
  'Adiri',
  'Agartha',
  'Akhet',
  'Akilineq',
  'Alatyr',
  'Alfheim',
  'Alomkik',
  'Amaravati',
  'Annwn',
  'Anor Londo',
  'Antillia',
  'Arcadia',
  'Arcadia Bay',
  'Arcterra',
  'Asgard',
  'Asphodel Meadows',
  'Atlantis',
  'Avalon',
  'Axis mundi',
  'Ayotha Amirtha Gangai',
  'Aztlán',
  'Bald Mountain',
  'Baltia',
  'Benben',
  'Biarmaland',
  'Biringan city',
  'Blood Gulch',
  'Brahmapura',
  'Brasil or Hy-Brasil',
  'Brittia',
  'Buyan',
  'Camelot',
  'Cantrer Gwaelod',
  'Capital Wasteland',
  'Chris Houlihan Room',
  'Citadel',
  'City of the Caesars',
  'Cloud cuckoo land',
  'Cockaigne',
  'Cow level',
  'Dinas Affaraon/Ffaraon',
  'Diyu',
  'Domdaniel',
  'Dust II',
  'Eight Pillars',
  'El Dorado',
  'Elysium',
  'Facing Worlds',
  'Feather Mountain',
  'Fortunate Isles',
  'Fositesland',
  'Fountain of Youth',
  'Four Treasures of the Tuatha Dé Danann',
  'Fusang',
  'Garden of Eden',
  'Garden of the Hesperides',
  'Gjöll',
  'Green Hill Zone',
  'Hara Berezaiti',
  'Hawaiki',
  'Heaven',
  'Hel',
  'Hell',
  'Himavanta',
  'Hitpun',
  'Hubur',
  'Hvergelmir',
  'Hyperborea',
  'Iram of the Pillars',
  'Irkalla',
  'Islands of the Blessed',
  'Ivalice',
  'Jabulqa and Jabulsa',
  'Jade Mountain',
  'Jambudvīpa',
  'Jotunheim',
  'Kalunga line',
  'Kamurochō',
  'Karshvar',
  'Ketumati',
  'Opona',
  'Prester John',
  'Reynes',
  'Saguenay',
  'Kitezh',
  'Kolob',
  'Kunlun Mountain',
  'Kvenland',
  'Kyöpelinvuori',
  'La Canela',
  'La Ciudad Blanca',
  'Laestrygon',
  'Lake Parime',
  'Land of Manu',
  'Lavender Town',
  'Lemuria',
  'Liberty City',
  'Lintukoto',
  'Longmen',
  'Los Santos',
  'Lost City of Z',
  'Lukomorye',
  'Lyonesse',
  'Mag Mell',
  'Mahoroba',
  'Megaton',
  'Meropis',
  'Mictlan',
  'Midgar',
  'Mímisbrunnr',
  'Mount Buzhou',
  'Mount Meru',
  'Mount of the Temptation',
  'Mount Olympus',
  'Mount Penglai',
  'Moving Sands',
  'Mu',
  'Mushroom Kingdom',
  'Muspelheim',
  'Naraka',
  'Nibiru',
  'Niflheim',
  'Niflhel',
  'Nirvana',
  'Normandy',
  'Norumbega',
  'Nysa',
  'Oddworld',
  'Olympus',
  'Paititi',
  'Pangaia',
  'Pandæmonium',
  'Piriawis',
  'Pleroma',
  'Pohjola',
  'Quivira and Cíbola',
  'Radiant Garden',
  'Rainbow Road',
  'Rama Setu',
  'Rapture',
  'Ravenholm',
  'Red River',
  'Rocabarraigh',
  'Ryūgū-jō',
  'Samavasarana',
  'Sanzu River',
  'Scholomance',
  'Section 37',
  'Shakdvipa',
  'Shambhala',
  'Shangri-La',
  'Sierra de la Plata',
  'SimNation',
  'Siniawis',
  'Spira',
  'Suddene',
  'Summerland',
  'Svarga',
  'Svartálfaheimr',
  'Takama-ga-hara',
  'Tartarus',
  'Tech Duinn',
  'Themiscyra',
  'Thule',
  'Thuvaraiyam Pathi',
  'Tír na nÓg',
  'Urðarbrunnr',
  'Uttarakuru',
  'Vaikuntha',
  'Vaitarna River',
  'Valhalla',
  'Vanaheimr',
  'Vineta',
  'Vyraj',
  'Water Temple',
  'Weak River',
  'Westernesse',
  'Xanadu',
  'Xibalba',
  'Yardna',
  'Yggdrasil',
  'Yharnam',
  'Yomi',
  'Ys',
  'Zarahemla',
  'Zerzura',
  'Abject',
  'Adventuresome',
  'Adventurous',
  'Apocalyptic',
  'Astronomical',
  'Audacious',
  'August',
  'Average',
  'Awesome',
  'Awful',
  'Bantam',
  'Baronial',
  'Big',
  'Bitty',
  'Bold',
  'Boundless',
  'Brash',
  'Brave',
  'Brazen',
  'Brobdingnagian',
  'Bulky',
  'Bumper',
  'Cavernous',
  'Celestial',
  'Chicken',
  'Chicken-Livered',
  'Chickenhearted',
  'Colossal',
  'Comforted',
  'Common',
  'Considerable',
  'Cosmic',
  'Courageous',
  'Coward',
  'Cowardly',
  'Craven',
  'Crazy',
  'Cyclopean',
  'Daredevil',
  'Daring',
  'Dashing',
  'Dastardly',
  'Dauntless',
  'Determined',
  'Diminutive',
  'Dinky',
  'Divine',
  'Doughty',
  'Dwarfish',
  'Elephantine',
  'Emboldened',
  'Encouraged',
  'Enormous',
  'Epic',
  'Extensive',
  'Extraordinary',
  'Extravagant',
  'Fainthearted',
  'Fearful',
  'Fearless',
  'Firm',
  'Foolhardy',
  'Foolish',
  'Formidable',
  'Galactic',
  'Gallant',
  'Game',
  'Gamy',
  'Gargantuan',
  'Giant',
  'Gigantesque',
  'Gigantic',
  'Glorious',
  'Good',
  'Goodly',
  'Gorgeous',
  'Grand',
  'Grandiose',
  'Great',
  'Greathearted',
  'Gritty',
  'Gross',
  'Gutless',
  'Gutsy',
  'Gutty',
  'Half-Pint',
  'Half-Witted',
  'Handsome',
  'Hardy',
  'Hasty',
  'Headlong',
  'Heartened',
  'Heavenly',
  'Heedless',
  'Hefty',
  'Herculean',
  'Himalayan',
  'Homeric',
  'Hotheaded',
  'Huge',
  'Hulking',
  'Humble',
  'Humongous',
  'Immeasurable',
  'Immense',
  'Imperial',
  'Impetuous',
  'Imposing',
  'Impressive',
  'Imprudent',
  'Impulsive',
  'Incautious',
  'Infinite',
  'Infinitesimal',
  'Inflated',
  'Insane',
  'Insignificant',
  'Intrepid',
  'Jumbo',
  'Killer',
  'King-Size',
  'Kingly',
  'Largish',
  'Lavish',
  'Leviathan',
  'Lilliputian',
  'Lily-Livered',
  'Lionhearted',
  'Little',
  'Little Bitty',
  'Lofty',
  'Lordly',
  'Lowly',
  'Lunatic',
  'Luxurious',
  'Mad',
  'Madcap',
  'Magnific',
  'Magnificent',
  'Majestic',
  'Major',
  'Mammoth',
  'Manful',
  'Marvelous',
  'Massive',
  'Mean',
  'Measly',
  'Mediocre',
  'Mega',
  'Meretricious',
  'Mettlesome',
  'Micro',
  'Microminiature',
  'Microscopic',
  'Midget',
  'Mighty',
  'Milk-Livered',
  'Mini',
  'Miniature',
  'Minuscule',
  'Minute',
  'Modest',
  'Monolithic',
  'Monster',
  'Monstrous',
  'Monumental',
  'Mountainous',
  'Nerveless',
  'Noble',
  'Nutty',
  'Oceanic',
  'Operatic',
  'Opulent',
  'Ordinary',
  'Outsize',
  'Overblown',
  'Overbold',
  'Overconfident',
  'Overgrown',
  'Oversize',
  'Overwhelming',
  'Palatial',
  'Palatine',
  'Paltry',
  'Petite',
  'Petty',
  'Pharaonic',
  'Pint-Size',
  'Planetary',
  'Plucky',
  'Pocket',
  'Poltroon',
  'Pompous',
  'Poor-Spirited',
  'Precipitate',
  'Prepossessing',
  'Princely',
  'Prodigious',
  'Proud',
  'Puny',
  'Pusillanimous',
  'Pygmy',
  'Queenly',
  'Rash',
  'Reassured',
  'Reckless',
  'Redoubtable',
  'Regal',
  'Remarkable',
  'Resolute',
  'Resplendent',
  'Royal',
  'Run-Of-The-Mill',
  'Second-Rate',
  'Sensational',
  'Shabby',
  'Sizable',
  'Small',
  'Smallish',
  'Sordid',
  'Spartan',
  'Spineless',
  'Spirited',
  'Spiritless',
  'Splendid',
  'Splendiferous',
  'Spunky',
  'Staggering',
  'Stalwart',
  'Stately',
  'Stout',
  'Stouthearted',
  'Striking',
  'Stupendous',
  'Sublime',
  'Substantial',
  'Sumptuous',
  'Super',
  'Super-Duper',
  'Superb',
  'Supersize',
  'Supersized',
  'Teensy',
  'Teensy-Weensy',
  'Teeny',
  'Teeny-Weeny',
  'Terrific',
  'Thoughtless',
  'Tidy',
  'Timorous',
  'Tiny',
  'Titanic',
  'Towering',
  'Tremendous',
  'Trifling',
  'Trivial',
  'Unafraid',
  'Uncourageous',
  'Undauntable',
  'Undaunted',
  'Undersized',
  'Undeterred',
  'Undismayed',
  'Unflinching',
  'Ungallant',
  'Unheroic',
  'Unimposing',
  'Unimpressive',
  'Unprepossessing',
  'Unswerving',
  'Valiant',
  'Valorous',
  'Vast',
  'Vasty',
  'Venturesome',
  'Venturous',
  'Voluminous',
  'Walloping',
  'Weakhearted',
  'Wee',
  'Whacking',
  'Whopping',
  'Wild',
  'Wonderful',
  'Wondrous',
  'Yellow',
];
